import * as React from "react";
import { SVGProps } from "react";

const Esbc = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 228 192" {...props}>
    <linearGradient
      id="a"
      x1={40.1}
      x2={204.3}
      y1={45}
      y2={192.8}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#8d5ae9" />
      <stop offset={1} stopColor="#63d1df" />
    </linearGradient>
    <path
      fill="url(#a)"
      d="M169.4 66.5a17 17 0 0 0 0 34 17 17 0 0 0 0-34zm0 25.4a8.4 8.4 0 0 1-8.3-8.4c0-4.6 3.7-8.4 8.3-8.4s8.3 3.8 8.3 8.4c0 4.6-3.7 8.4-8.3 8.4zM60.2 66.5a17 17 0 0 0 0 34 17 17 0 0 0 0-34zm0 25.4a8.4 8.4 0 0 1-8.3-8.4c0-4.6 3.7-8.4 8.3-8.4s8.3 3.8 8.3 8.4c0 4.6-3.7 8.4-8.3 8.4zm49 17.7H97.6V97.9h11.7v11.7zm21.3 0h-11.7V97.9h11.7v11.7zm91.4 46.5-7.5-58.4-1.3-10.1-.4-3.7a46.5 46.5 0 0 0-45.4-41.4V.1l-21.4 12.3V5.9l-8.9 5.3-10.1 5.8V9.2l-18.8 10.6V5.2l-21 12.2V8.8L59.4 25v17.7A46.6 46.6 0 0 0 16.7 84l-.4 3.6c-.4 3.3-.7 6.8-1.3 10.3l-7.5 58.3a32.2 32.2 0 0 0 59.7 20.9l18.2-30.8c2.3-3.9 6.5-6.4 11-6.4H133c4.5 0 8.7 2.4 11 6.4l18.2 30.8a32.2 32.2 0 0 0 59.7-21zm-14.3 20.2a23.5 23.5 0 0 1-37.9-3.7l-18.2-30.8a21.5 21.5 0 0 0-18.4-10.6H96.4c-7.5 0-14.6 4.1-18.4 10.6l-18.2 30.8a23.3 23.3 0 0 1-37.9 3.7 24.2 24.2 0 0 1-5.8-19.1L23.6 99c.6-3.5.9-7.1 1.3-10.5l.4-3.5a37.9 37.9 0 0 1 61.3-25.3 42 42 0 0 0 26.8 9.9h2.9c9.5 0 19-3.5 26.8-9.9a37.4 37.4 0 0 1 23.7-8.5A37.9 37.9 0 0 1 204.3 85l.4 3.6 1.3 10.3 7.5 58.3c.8 6.9-1.3 13.9-5.9 19.1z"
    />
    <linearGradient
      id="b"
      x1={100.9}
      x2={128.8}
      y1={155.4}
      y2={180.5}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#7b8de5" />
      <stop offset={1} stopColor="#70ade2" />
    </linearGradient>
    <path
      fill="none"
      stroke="url(#b)"
      strokeMiterlimit={10}
      strokeWidth={8}
      d="M92.2 165.4c11.2 11 34.2 10.9 45.2-.3"
    />
  </svg>
);

export default Esbc;
